import { combineReducers } from "redux";
import externalLinksOverviewReducer from "./ExternalLinksOverviewSlice";
import externalLinkEntityStateReducer from "./ExternalLinkEntityStateSlice";
import externalLinkDetailsReducer from "./ExternalLinkDetailsSlice";
import externalLinksFiltersReducer from "./ExternalLinksFiltersSlice";

const externalLinksReducer = combineReducers({
  overview: externalLinksOverviewReducer,
  filters: externalLinksFiltersReducer,
  entityState: externalLinkEntityStateReducer,
  details: externalLinkDetailsReducer,
});

export type ExternalLinksState = ReturnType<typeof externalLinksReducer>;

export default externalLinksReducer;
